module.exports = __webpack_public_path__ + "static/img/xiazailuyin.713cc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiazailuyin.png
// module id = /uYZ
// module chunks = 24